var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs-items"},_vm._l((_vm.brItems),function(item,index){return _c('span',{key:index,staticClass:"breadcrumbs-item-wrapper",class:{
      first: index === 0,
    }},[_c('span',{staticClass:"breadcrumbs-item",class:{
        clickable: item.to,
      },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.to(item.to)}}},[_vm._v(_vm._s(item.name))]),(index < _vm.brItems.length - 1)?_c('span',{staticClass:"breadcrumbs-divider"},[_vm._v("/")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }